export const DigitalDownloadType = {
  SFLY: 'SFLY',
  SOCIAL: 'SOCIAL'
} as const;

export type DigitalDownloadType = (typeof DigitalDownloadType)[keyof typeof DigitalDownloadType];
